const Conventionals = {
  cells: {
    hct: {
      neonate: {
        snug: 18, // need blood transfusion
        lo: 47,
        hi: 67,
        crical: 70, // Panic Value
        alert: 75,
        unit: "%",
      },
      infant: { snug: 18, lo: 37, hi: 41, crical: 50, alert: 55, unit: "%" },
      child: { snug: 18, lo: 32, hi: 42, crical: 50, alert: 55, unit: "%" },
      adult: {
        Male: {
          snug: 18,
          lo: 40,
          hi: 54,
          warn: 60,
          alert: 65,
          crical: 70,
          unit: "%",
        },
        Female: {
          snug: 18,
          lo: 36,
          hi: 47,
          warn: 50,
          alert: 55,
          crical: 60,
          unit: "%",
        },
      },
      hgb: {
        neonate: {
          snug: 6.0,
          lo: 17.0,
          hi: 22.0,
          warn: 24.0,
          alert: 26.0,
          crical: 28.0,
          unit: "g%",
        },
        infant: {
          snug: 6.0,
          lo: 11.0,
          hi: 12.5,
          warn: 16.0,
          alert: 18.0,
          crical: 20.0,
          unit: "g%",
        },
        child: {
          snug: 6.0,
          lo: 12.0,
          hi: 14.0,
          warn: 17.0,
          alert: 18.0,
          crical: 20.0,
          unit: "g%",
        },
        adult: {
          Male: {
            snug: 6.0,
            lo: 13.0,
            hi: 18.0,
            warn: 20.0,
            alert: 21.0,
            crical: 22.0,
            unit: "g%",
          },
          Female: {
            snug: 6.0,
            lo: 11.5,
            hi: 16.5,
            warn: 18.0,
            alert: 19.0,
            crical: 20.0,
            unit: "g%",
          },
        },
      },
      rbc: {
        neonate: {
          snug: 1.98,
          lo: 4.7,
          hi: 6.1,
          warn: 6.6,
          alert: 7.0,
          crical: 7.5,
          unit: "x10⁶/mm³",
        },
        infant: {
          snug: 1.98,
          lo: 3.95,
          hi: 4.75,
          warn: 5.5,
          alert: 6.0,
          crical: 6.5,
          unit: "x10⁶/mm³",
        },
        child: {
          snug: 1.98,
          lo: 4.5,
          hi: 5.5,
          warn: 6.0,
          alert: 6.5,
          crical: 7.0,
          unit: "x10⁶/mm³",
        },
        adult: {
          Male: {
            snug: 1.98,
            lo: 4.6,
            hi: 6.2,
            warn: 6.6,
            alert: 7.0,
            crical: 7.5,
            unit: "x10⁶/mm³",
          },
          Female: {
            snug: 1.98,
            lo: 4.2,
            hi: 5.4,
            warn: 6.0,
            alert: 6.5,
            crical: 6.8,
            unit: "x10⁶/mm³",
          },
        },
      },
      wbc: {
        neonate: {
          snug: 1,
          lo: 10,
          hi: 30,
          warn: 35,
          alert: 40,
          crical: 45,
          unit: "x10³/mm³",
        },
        infant: {
          snug: 1,
          lo: 6,
          hi: 20,
          warn: 25,
          alert: 30,
          crical: 35,
          unit: "x10³/mm³",
        },
        child: {
          snug: 1,
          lo: 5,
          hi: 15,
          warn: 18,
          alert: 20,
          crical: 25,
          unit: "x10³/mm³",
        },
        adult: {
          Male: {
            snug: 1,
            lo: 4,
            hi: 10,
            warn: 15,
            alert: 18,
            crical: 20,
            unit: "x10³/mm³",
          },
          Female: {
            snug: 1,
            lo: 4,
            hi: 10,
            warn: 15,
            alert: 18,
            crical: 25,
            unit: "x10³/mm³",
          },
        },
      },
    },
  },
  plt: {
    snug: 100,
    lo: 150,
    hi: 450,
    warn: 600,
    alert: 800,
    crical: 1000,
    unit: "x10³/µL",
  },
  differentials: {
    Segmenters: {
      neonate: { snug: 0, lo: 0, hi: 25, warn: 70, alert: 75, crical: 80 },
      infant: { snug: 0, lo: 0, hi: 22, warn: 60, alert: 65, crical: 70 },
      child: { snug: 0, lo: 31, hi: 61, warn: 70, alert: 75, crical: 80 },
      adult: { snug: 20, lo: 36, hi: 66, warn: 70, alert: 75, crical: 80 },
    },
    Lymphocytes: {
      neonate: { snug: 0, lo: 0, hi: 57, warn: 70, alert: 80, crical: 85 },
      infant: { snug: 0, lo: 0, hi: 63, warn: 70, alert: 80, crical: 85 },
      child: { snug: 0, lo: 28, hi: 38, warn: 45, alert: 50, crical: 55 },
      adult: { snug: 0, lo: 24, hi: 44, warn: 50, alert: 55, crical: 60 },
    },
    Monocytes: {
      neonate: { snug: 0, lo: 0, hi: 7, warn: 10, alert: 15, crical: 20 },
      infant: { snug: 0, lo: 0, hi: 5, warn: 8, alert: 10, crical: 15 },
      child: { snug: 0, lo: 0, hi: 5, warn: 8, alert: 10, crical: 15 },
      adult: { snug: 0, lo: 0, hi: 4, warn: 8, alert: 10, crical: 15 },
    },
    Eosinophils: {
      neonate: { snug: 0, lo: 0, hi: 3, warn: 5, alert: 10, crical: 20 },
      infant: { snug: 0, lo: 0, hi: 3, warn: 5, alert: 10, crical: 20 },
      child: { snug: 0, lo: 0, hi: 3, warn: 5, alert: 10, crical: 20 },
      adult: { snug: 0, lo: 0, hi: 3, warn: 5, alert: 10, crical: 20 },
    },
    Stabs: {
      neonate: { snug: 0, lo: 0, hi: 8, warn: 10, alert: 15, crical: 20 },
      infant: { snug: 0, lo: 0, hi: 8, warn: 10, alert: 15, crical: 20 },
      child: { snug: 0, lo: 5, hi: 11, warn: 15, alert: 20, crical: 25 },
      adult: { snug: 0, lo: 5, hi: 11, warn: 15, alert: 20, crical: 25 },
    },
    Basophils: {
      neonate: { snug: 0, lo: 0, hi: 1, warn: 1.5, alert: 2, crical: 3 },
      infant: { snug: 0, lo: 0, hi: 1, warn: 1.5, alert: 2, crical: 3 },
      child: { snug: 0, lo: 0, hi: 1, warn: 1.5, alert: 2, crical: 3 },
      adult: { snug: 0, lo: 0, hi: 1, warn: 1.5, alert: 2, crical: 3 },
    },
  },
  rci: {
    MCV: {
      neonate: { snug: 0, lo: 108, hi: 136, crical: 150, unit: "µm³" },
      infant: { snug: 0, lo: 82, hi: 98, crical: 120, unit: "µm³" },
      child: { snug: 0, lo: 75, hi: 87, crical: 100, unit: "µm³" },
      adult: { snug: 0, lo: 85, hi: 95, crical: 115, unit: "µm³" },
    },
    MCH: {
      neonate: { snug: 0, lo: 29, hi: 35, crical: 40, unit: "pg" },
      infant: { snug: 0, lo: 24, hi: 30, crical: 35, unit: "pg" },
      child: { snug: 0, lo: 25, hi: 31, crical: 36, unit: "pg" },
      adult: { snug: 0, lo: 28, hi: 32, crical: 37, unit: "pg" },
    },
    MCHC: {
      neonate: { snug: 0, lo: 28, hi: 32, crical: 40, unit: "g/dL" },
      infant: { snug: 0, lo: 29, hi: 31, crical: 39, unit: "g/dL" },
      child: { snug: 0, lo: 33, hi: 35, crical: 40, unit: "g/dL" },
      adult: { snug: 0, lo: 32, hi: 36, crical: 41, unit: "g/dL" },
    },
    RDWc: {
      neonate: { snug: 0, lo: 11.5, hi: 14.5, crical: 15, unit: "%" },
      infant: { snug: 0, lo: 11.5, hi: 14.5, crical: 15, unit: "%" },
      child: { snug: 0, lo: 11.5, hi: 14.5, crical: 15, unit: "%" },
      adult: { snug: 0, lo: 11.5, hi: 14.5, crical: 15, unit: "%" },
    },
  },
};

export default Conventionals;
